// extracted by mini-css-extract-plugin
export default {"image":"_2_u5KBdW","link":"_1o4lbwT8","message":"_1EQM8WWF","timestamp":"_2069BIDg","text":"_1QYd6zri"};